import { SvgIcon } from "@material-ui/core";
import React from "react";

const ClassificationIcon = props => (
  <SvgIcon>
    <g id="Icon/ClassificationIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox={props.viewBox}
      >
        <g
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.6"
          clipPath="url(#ClassificationIcon)"
        >
          <path d="M10 10V4.375M10 15v-4.375M17.5 15v-5M2.5 15v-5M2.5 10h15M4.375 15.625H.625v3.75h3.75v-3.75zM11.875 15.625h-3.75v3.75h3.75v-3.75zM19.375 15.625h-3.75v3.75h3.75v-3.75zM16.875.625H3.75v3.75h13.125V.625z"/>
        </g>
        <defs>
          <clipPath id="ClassificationIcon">
            <path fill="#fff" d="M0 0H20V20H0z"/>
          </clipPath>
        </defs>
      </svg>
    </g>
  </SvgIcon>
);

export default ClassificationIcon;



// WEBPACK FOOTER //
// ./src/icons/ClassificationIcon.jsx